/* eslint-disable prettier/prettier */
const url = new URL(window.location.href)
const host = `${url.protocol}//${url.host}/`

const endpoints = {
    get FIBER_API_URL() {
      return host;
    },
    get AUTH_API_URL() {
      return host;
    },
    get FIELD_API_URL() {
      return host;
    },
    get WS_URL() {
      return `${host}ws1/notifications`;
    },
    get IS_BIDDING(){
      return false;
    },
    get FIBER_CLIENT_URL() {
      return host;
    },
    get BIDDING_CLIENT_URL() {
      return host;
    },
    host_default:  null
  };
  
  
  export default endpoints;
  


// WEBPACK FOOTER //
// ./src/utils/endpoints.js